import { Dashboard, ExitToApp } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { LogoIcon } from 'src/components';
import { SCRoutes } from 'src/config';
import { LOGOUT_ACTION_START } from 'src/features/auth/auth.types';
import { NavSubscriptionOCM } from 'src/features/ocm/NavSubscriptionOCM';
import { userSelector } from 'src/features/user/store';
import { useUserRole } from 'src/hooks/useUserRole';
import styled from 'styled-components';
import { UserHeader } from './UserHeader';

const Wrapper = styled.div`
  height: 50px;
`;

type Props = {
  testID?: string;
};

export const SiteHeader: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { info } = useSelector(userSelector);

  const location = useLocation();

  const { LEVEL_MANAGER } = useUserRole();
  const dispatch = useDispatch();

  const logout = useCallback(() => {
    dispatch({ type: LOGOUT_ACTION_START });
  }, [dispatch]);

  if (!info) {
    return null;
  }

  return (
    <div className="fixed w-screen">
      <NavSubscriptionOCM />
      <Wrapper className="bg-dark py-2 px-4 text-white  flex items-center space-x-2 flex-row justify-between">
        <Link to="/">
          <LogoIcon color="#fff" height={30} width={100} />
        </Link>
        <div className="flex flex-row space-x-2 items-center mx-1yrn">
          {!!info && <UserHeader userName={info.firstName} />}
          <Button variant="contained" endIcon={<ExitToApp />} color="warning" onClick={logout}>
            {t('menu.logout')}
          </Button>

          {!!info && LEVEL_MANAGER && !location.pathname.startsWith(SCRoutes.dashboard.home) && (
            <Button
              component={Link}
              to={SCRoutes.dashboard.home}
              variant="contained"
              endIcon={<Dashboard />}
              color="success"
            >
              {t('dashboard.cta-manage')}
            </Button>
          )}
        </div>
      </Wrapper>
    </div>
  );
};
